import { render, staticRenderFns } from "./WaitingForDraw.vue?vue&type=template&id=41b2bff0&scoped=true"
import script from "./WaitingForDraw.vue?vue&type=script&lang=js"
export * from "./WaitingForDraw.vue?vue&type=script&lang=js"
import style0 from "./WaitingForDraw.vue?vue&type=style&index=0&id=41b2bff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b2bff0",
  null
  
)

export default component.exports